import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="/vfit-logo.jpg" alt="V-Fit Training" className="footer-logo-img" />
            <p className="footer-tagline">
              Transform Your Body. Reclaim Your Strength.
            </p>
            <div className="footer-social">
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h4 className="footer-heading">Quick Links</h4>
            <button onClick={() => scrollToSection('about')} className="footer-link">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="footer-link">
              Services
            </button>
            <button onClick={() => scrollToSection('results')} className="footer-link">
              Results
            </button>
            <button onClick={() => scrollToSection('contact')} className="footer-link">
              Contact
            </button>
          </div>

          <div className="footer-contact">
            <h4 className="footer-heading">Contact</h4>
            <div className="footer-contact-item">
              <Phone size={16} />
              <a href="tel:2392730074">(239) 273-0074</a>
            </div>
            <div className="footer-contact-item">
              <Mail size={16} />
              <a href="mailto:vincent.acquaro07@gmail.com">vincent.acquaro07@gmail.com</a>
            </div>
            <div className="footer-contact-item">
              <MapPin size={16} />
              <span>Southwest Florida</span>
            </div>
          </div>

          <div className="footer-certifications">
            <h4 className="footer-heading">Certifications</h4>
            <p className="cert-text">ISSA Certified Personal Trainer</p>
            <p className="cert-text">10+ Years Training Experience</p>
            <p className="cert-text">Specialized Nutrition Programming</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} V-Fit. All rights reserved. | Vincent Acquaro - Southwest Florida Personal Trainer
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
